export default "__VITE_ASSET__$rbm_I$E__"